import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AnnouncementsModel } from '@core/models';
import { LayoutState } from '@core/state/shared';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-latest-news-popup',
  templateUrl: './latest-news-popup.component.html',
  styleUrls: ['./latest-news-popup.component.scss'],
})
export class LatestNewsPopupComponent implements OnInit {
  @Input()
  public slides: AnnouncementsModel[];

  @Output() closePopup = new EventEmitter();

  public steps: { label: string }[];
  public opened = true;
  public currentStepIndex = 0;

  constructor(public layoutState: LayoutState) {}

  public ngOnInit(): void {
    this.steps = this.slides.map((param, index) => ({
      label: `Paso ${index + 1}`,
    }));
  }

  public close(): void {
    this.opened = !this.opened;
    this.closePopup.emit();
  }

  nextStep() {
    if (this.currentStepIndex < this.slides.length - 1) {
      this.currentStepIndex++;
    }
  }

  prevStep() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
    }
  }
}
